const betfoundersTaxes = {
  currency: 'etb',

  /**
   * @param {number} stake
   * @param {number} odd
   * @param {(value: number) => number} roundCurrency
   *
   * @returns {{vatAmount: number, stakeAfterVat: number, incomeTax: number, possibleWin: number}}
   */
  getTaxes(stake, odd, roundCurrency) {
    const vat = roundCurrency(stake - stake / this.vat);
    const stakeAfterVat = roundCurrency(stake - vat);
    const possibleWinAfterVat = stakeAfterVat * odd;
    const incomeTax =
      possibleWinAfterVat > this.incomeTaxMinSum
        ? roundCurrency(possibleWinAfterVat * this.incomeTax)
        : 0;
    const possibleWin = roundCurrency(possibleWinAfterVat - incomeTax);

    return {
      incomeTax: Number(incomeTax),
      possibleWin,
      stakeAfterVat,
      vatAmount: Number(vat),
    };
  },
  incomeTax: 0.15,
  incomeTaxMinSum: 1000,
  incomeTaxValueStr: '15%',
  vat: 1.15,
  vatValueStr: 'VAT 15%',
};

/** @type {{[key: string]: typeof betfoundersTaxes}} */
export const taxes = {
  'betfounders-stage-sportsbook': betfoundersTaxes,
};
